import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/Switching/ecs-48-poe@2x.jpg";
import v3Image from "../../assets/Switching/enterpriseCampus48.jpg";
import type { Product } from "../../types";
import { productListSwitchingEnterprise } from "../product-list-groups/productListSwitchingEnterprise";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const enterpriseCampus48PoE: Product = {
  id: "enterpriseCampus48PoE",
  productTitle: "Enterprise Campus 48 PoE",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/ecs-48-poe`,
  ],
  storePathParts: {
    productSlug: "ecs-48-poe",
    category: UniFiChildCategorySlug.SwitchingEnterprise,
  },
  sku: "ECS-48",
  description: "enterpriseCampus48PoE.description",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 230,
    height: 120,
  },
  productListGroup: productListSwitchingEnterprise,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442.4 x 43.7 x 496 mm\n(17.4 x 1.7 x 19.5")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "48" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo10Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "25 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "string", value: "PoE+++" },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "2150 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.dualHotSwappablePsus",
      },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
